
import React from 'react'
import ReactPlayer from 'react-player'
import Img from 'gatsby-image'

import { withStyles } from '@material-ui/core/styles'
import styles from './styles'

class Poster extends React.Component {
  state = {
    isIOS: false,
  }

  componentDidMount() {
    this.setState({
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
    })
  }

  render() {
    const { classes, image, urls, poster } = this.props
    const { isIOS } = this.state


    return !isIOS && urls ? (
      <ReactPlayer
        ref={p => (this.player = p)}
        url={urls[0].src}
        width={'100%'}
        height={'100%'}
        loop
        autoPlay
        playing
        muted
      />
    ) : (
      image.src !== {} ? (<img src={image.src} className={classes.poster} alt={image.alt} />) : (<div className={classes.poster}/>)
    )
  }
}

export default withStyles(styles)(Poster)



// WEBPACK FOOTER //
// ./src/components/poster/index.js